import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "Gulf of Mexico Energy Security Act (GOMESA) | How revenue works",
  "includeToc": true,
  "description": "The Gulf of Mexico Energy Security Act (GOMESA) of 2006 created a revenue-sharing model for oil- and gas-producing gulf states. Under the act, Alabama, Louisiana, Mississippi, and Texas receive a portion of the revenue generated from oil and gas production offshore in the Gulf of Mexico. The act also directs a portion of revenue to the Land and Water Conservation Fund.",
  "tags": ["How revenue works", "Gulf of Mexico", "Federal laws", "Regulations", "GOMESA", "Land and Water Conservation Fund", "Revenue", "Disbursements", "Alabama", "Louisiana", "Mississippi", "Texas"]
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const GlossaryTerm = makeShortcode("GlossaryTerm");
const Table = makeShortcode("Table");
const TableHead = makeShortcode("TableHead");
const TableRow = makeShortcode("TableRow");
const TableCell = makeShortcode("TableCell");
const TableBody = makeShortcode("TableBody");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "/sites/VDP/how-revenue-works/"
      }}>{`How revenue works /`}</a></p>
    <h1 {...{
      "id": "Gulf-of-Mexico-Energy-Security-Act-GOMESA",
      "style": {
        "position": "relative"
      }
    }}>{`Gulf of Mexico Energy Security Act (GOMESA)`}</h1>
    <p>{`The Gulf of Mexico Energy Security Act (GOMESA) of 2006 created a revenue-sharing model for oil- and gas-producing gulf states. Under the act, Alabama, Louisiana, Mississippi, and Texas receive a portion of the revenue generated from oil and gas production offshore in the Gulf of Mexico. The act also directs a portion of revenue to the Land and Water Conservation Fund.`}</p>
    <h2 {...{
      "id": "Revenue-sharing",
      "style": {
        "position": "relative"
      }
    }}>{`Revenue sharing`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.boem.gov/GOMESA/"
      }}>{`Gulf of Mexico Energy Security Act of 2006 (PDF)`}</a>{` (GOMESA) created revenue-sharing provisions for four states and their `}<GlossaryTerm mdxType="GlossaryTerm">{`coastal political subdivisions`}</GlossaryTerm>{`:`}</p>
    <ul>
      <li parentName="ul">{`Alabama`}</li>
      <li parentName="ul">{`Louisiana`}</li>
      <li parentName="ul">{`Mississippi`}</li>
      <li parentName="ul">{`Texas`}</li>
    </ul>
    <h3 {...{
      "id": "GOMESA-disbursements",
      "style": {
        "position": "relative"
      }
    }}>{`GOMESA disbursements`}</h3>
    <p>{`The Office of Natural Resources Revenue disburses GOMESA revenue to both state and local governments for each of the four GOMESA states. The numbers below show the disbursements to the states and their local governments and are made the year following the year of receipt and subject to sequestration.`}</p>
    <h4 {...{
      "id": "Alabama",
      "style": {
        "position": "relative"
      }
    }}>{`Alabama`}</h4>
    <Table mdxType="Table">
    <TableHead mdxType="TableHead">
    <TableRow mdxType="TableRow">
        <TableCell mdxType="TableCell">Recipient</TableCell>
        <TableCell mdxType="TableCell">Fiscal Year 2022 Disbursement</TableCell>
    </TableRow>
    </TableHead>
    <TableBody mdxType="TableBody">
        <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">State of Alabama</TableCell><TableCell mdxType="TableCell">$27,868,611</TableCell></TableRow>
        <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Baldwin County</TableCell><TableCell mdxType="TableCell">$3,273,311</TableCell></TableRow>
        <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Mobile County</TableCell><TableCell mdxType="TableCell">$3,693,841</TableCell></TableRow>
        <TableRow mdxType="TableRow"><TableCell mdxType="TableCell"><b>Alabama Total</b></TableCell><TableCell mdxType="TableCell"><b>$34,835,764</b></TableCell></TableRow>
        </TableBody>
    </Table>
 <Link href='/query-data/?dataType=Disbursements&period=Fiscal%20Year&fiscalYear=2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021&groupBy=localRecipient&usStateName=Alabama&source=GOMESA%20offshore' linkType='FilterTable' mdxType="Link">View FY 2009 - FY 2021 Alabama GOMESA disbursements</Link>
    <h4 {...{
      "id": "Louisiana",
      "style": {
        "position": "relative"
      }
    }}>{`Louisiana`}</h4>
    <Table mdxType="Table">
    <TableHead mdxType="TableHead">
    <TableRow mdxType="TableRow">
        <TableCell mdxType="TableCell">Recipient</TableCell>
        <TableCell mdxType="TableCell">Fiscal Year 2022 Disbursement</TableCell>
    </TableRow>
    </TableHead>
    <TableBody mdxType="TableBody">
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">State of Louisiana</TableCell><TableCell mdxType="TableCell">$89,457,676</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Assumption Parish</TableCell><TableCell mdxType="TableCell">$734,401</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Calcasieu Parish</TableCell><TableCell mdxType="TableCell">$1,212,645</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Cameron Parish</TableCell><TableCell mdxType="TableCell">$1,503,763</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Iberia Parish</TableCell><TableCell mdxType="TableCell">$1,159,153</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Jefferson Parish</TableCell><TableCell mdxType="TableCell">$1,814,646</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Lafourche Parish</TableCell><TableCell mdxType="TableCell">$1,152,790</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Livingston Parish</TableCell><TableCell mdxType="TableCell">$948,033</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Orleans Parish</TableCell><TableCell mdxType="TableCell">$1,589,445</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Plaquemines Parish</TableCell><TableCell mdxType="TableCell">$2,174,817</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. Bernard Parish</TableCell><TableCell mdxType="TableCell">$1,064,029</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. Charles Parish</TableCell><TableCell mdxType="TableCell">$786,007</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. James Parish</TableCell><TableCell mdxType="TableCell">$685,598</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. John The Baptist Parish</TableCell><TableCell mdxType="TableCell">$734,005</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. Martin Parish</TableCell><TableCell mdxType="TableCell">$826,163</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. Mary Parish</TableCell><TableCell mdxType="TableCell">$961,124</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">St. Tammany Parish</TableCell><TableCell mdxType="TableCell">$1,265,671</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Tangipahoa Parish</TableCell><TableCell mdxType="TableCell">$908,398</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Terrebonne Parish</TableCell><TableCell mdxType="TableCell">$1,687,430</TableCell></TableRow>
          <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Vermilion Parish</TableCell><TableCell mdxType="TableCell">$1,156,300</TableCell></TableRow>
        <TableRow mdxType="TableRow"><TableCell mdxType="TableCell"><b>Louisiana Total</b></TableCell><TableCell mdxType="TableCell"><b>$111,822,095</b></TableCell></TableRow>
        </TableBody>
        </Table>
 <Link href='https://nrrd-preview.app.cloud.gov/sites/upload-data/query-data/?dataType=Disbursements&period=Fiscal%20Year&fiscalYear=2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021&groupBy=localRecipient&usStateName=Louisiana&source=GOMESA%20offshore' linkType='FilterTable' mdxType="Link">View FY 2009 - FY 2021 Louisiana GOMESA disbursements</Link>
    <h4 {...{
      "id": "Mississippi",
      "style": {
        "position": "relative"
      }
    }}>{`Mississippi`}</h4>
    <Table mdxType="Table">
    <TableHead mdxType="TableHead">
    <TableRow mdxType="TableRow">
        <TableCell mdxType="TableCell">Recipient</TableCell>
        <TableCell mdxType="TableCell">Fiscal Year 2022 Disbursement</TableCell>
    </TableRow>
    </TableHead>
    <TableBody mdxType="TableBody">
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">State of Mississippi</TableCell><TableCell mdxType="TableCell">$29,417,448</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Hancock County</TableCell><TableCell mdxType="TableCell">$1,398,765</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Harrison County</TableCell><TableCell mdxType="TableCell">$2,898,940</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Jackson County</TableCell><TableCell mdxType="TableCell">$3,056,657</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell"><b>Mississippi Total</b></TableCell><TableCell mdxType="TableCell"><b>$36,771,811</b></TableCell></TableRow>
    </TableBody>
    </Table>
 <Link href='/query-data/?dataType=Disbursements&period=Fiscal%20Year&fiscalYear=2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021&groupBy=localRecipient&usStateName=Mississippi&source=GOMESA%20offshore' linkType='FilterTable' mdxType="Link">View FY 2009 - FY 2021 Mississippi GOMESA disbursements</Link>
    <h4 {...{
      "id": "Texas",
      "style": {
        "position": "relative"
      }
    }}>{`Texas`}</h4>
    <Table mdxType="Table">
    <TableHead mdxType="TableHead">
    <TableRow mdxType="TableRow">
        <TableCell mdxType="TableCell">Recipient</TableCell>
        <TableCell mdxType="TableCell">Fiscal Year 2022 Disbursement</TableCell>
    </TableRow>
    </TableHead>
    <TableBody mdxType="TableBody">
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">State of Texas</TableCell><TableCell mdxType="TableCell">$55,066,869</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Aransas County</TableCell><TableCell mdxType="TableCell">$556,466</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Brazoria County</TableCell><TableCell mdxType="TableCell">$924,030</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Calhoun County</TableCell><TableCell mdxType="TableCell">$743,591</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Cameron County</TableCell><TableCell mdxType="TableCell">$783,679</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Chambers County</TableCell><TableCell mdxType="TableCell">$476,407</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Galveston County</TableCell><TableCell mdxType="TableCell">$1,213,009</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Harris County</TableCell><TableCell mdxType="TableCell">$2,726,813</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Jackson County</TableCell><TableCell mdxType="TableCell">$357,860</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Jefferson County</TableCell><TableCell mdxType="TableCell">$913,428</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Kenedy County</TableCell><TableCell mdxType="TableCell">$769,866</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Kleberg County</TableCell><TableCell mdxType="TableCell">$553,625</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Matagorda County</TableCell><TableCell mdxType="TableCell">$1,059,884</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Nueces County</TableCell><TableCell mdxType="TableCell">$720,209</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Orange County</TableCell><TableCell mdxType="TableCell">$453,016</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Refugio County</TableCell><TableCell mdxType="TableCell">$342,621</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">San Patricio County</TableCell><TableCell mdxType="TableCell">$359,163</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Victoria County</TableCell><TableCell mdxType="TableCell">$368,561</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell">Willacy County</TableCell><TableCell mdxType="TableCell">$444,490</TableCell></TableRow>
    <TableRow mdxType="TableRow"><TableCell mdxType="TableCell"><b>Texas Total</b></TableCell><TableCell mdxType="TableCell"><b>$68,833,587</b></TableCell></TableRow>
        </TableBody>
    </Table>
 <Link href='/query-data/?dataType=Disbursements&period=Fiscal%20Year&fiscalYear=2009%2C2010%2C2011%2C2012%2C2013%2C2014%2C2015%2C2016%2C2017%2C2018%2C2019%2C2020%2C2021&groupBy=localRecipient&usStateName=Texas&source=GOMESA%20offshore' linkType='FilterTable' mdxType="Link">View FY 2009 - FY 2021 Texas GOMESA disbursements</Link>
    <h3 {...{
      "id": "Land-and-Water-Conservation-Fund",
      "style": {
        "position": "relative"
      }
    }}>{`Land and Water Conservation Fund`}</h3>
    <p>{`The act also directs a portion of gulf revenue to the `}<a parentName="p" {...{
        "href": "/sites/VDP/how-revenue-works/lwcf/"
      }}>{`Land and Water Conservation Fund`}</a>{`, which supports preservation, development, and access to outdoor lands for public recreation.`}</p>
    <h3 {...{
      "id": "Purpose-of-funds",
      "style": {
        "position": "relative"
      }
    }}>{`Purpose of funds`}</h3>
    <p>{`GOMESA funds are to be used for coastal conservation, restoration, and hurricane protection.`}</p>
    <h2 {...{
      "id": "Phases",
      "style": {
        "position": "relative"
      }
    }}>{`Phases`}</h2>
    <p>{`There are two phases of GOMESA revenue sharing:`}</p>
    <p><strong parentName="p">{`Phase I`}</strong>{`: Since 2007, 37.5% of all qualified gulf revenues are shared among the four states and their coastal political subdivisions. Revenues are generated from leases in specific geographic areas defined in the act. Additionally, 12.5% of revenues are disbursed to the Land and Water Conservation Fund.`}</p>
    <p><strong parentName="p">{`Phase II`}</strong>{`: The second phase of GOMESA revenue sharing started in fiscal year 2017. It expands the `}<Link linkType='default' href='/downloads/gomesa-map.pdf' mdxType="Link">{`areas that qualify for revenue-sharing (PDF)`}</Link>{` under GOMESA.`}</p>
    <p>{`Phase II also imposes revenue-sharing caps on states and the Land and Water Conservation Fund. Overall state revenue-sharing caps are:`}</p>
    <ul>
      <li parentName="ul">{`$375 million for fiscal years 2017–2019`}</li>
      <li parentName="ul">{`$487.5 million for fiscal years 2020 and 2021`}</li>
      <li parentName="ul">{`$375 million for fiscal years 2022–2055`}</li>
    </ul>
    <p>{`The cap is lifted beginning in fiscal year 2056.`}</p>
    <h2 {...{
      "id": "Expanded-leasing-area",
      "style": {
        "position": "relative"
      }
    }}>{`Expanded leasing area`}</h2>
    <p>{`The act stipulated 8.3 million acres be offered for oil and gas leasing shortly after the enactment of the statute. This acreage is included in the Central Gulf Planning Area and the Eastern Gulf Planning Area.`}</p>
    <h2 {...{
      "id": "Extended-moratorium",
      "style": {
        "position": "relative"
      }
    }}>{`Extended moratorium`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.boem.gov/Areas-Under-Moratoria/"
      }}>{`GOMESA Moratorium`}</a>{` covers a portion of the Central Gulf of Mexico Planning Area and — until 2022 — most of the Eastern Gulf of Mexico Planning Area.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      